module.exports = __webpack_public_path__ + "img/bank.f5cc9467.svg";